import { __read } from "tslib";
import { useEffect, useState } from 'react';
import { globalThemeMode, themeModeSnapshot, } from '../operations/setGlobalTheme';
// Surfaces the global theme mode (Light/Dark/HC) set by setGlobalTheme.
// Most js theme usages should rely on Fluent useTheme and makeStyles or useThemeMode hook rather than referencing the global theme mode.
export function useGlobalThemeMode() {
    var _a = __read(useState(themeModeSnapshot), 2), themeMode = _a[0], setThemeMode = _a[1];
    useEffect(function () {
        var themeSubscription = globalThemeMode.subscribe(setThemeMode);
        return function () {
            themeSubscription === null || themeSubscription === void 0 ? void 0 : themeSubscription.unsubscribe();
        };
    }, []);
    return themeMode;
}
//# sourceMappingURL=useGlobalThemeMode.js.map